// extracted by mini-css-extract-plugin
module.exports = {"archidekt":"DecklistPanel_archidekt__Up_vh","code":"DecklistPanel_code__pZfEA"};